import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { FORM_PLAN_DE_EMBARQUE } from '../../../../config/forms'
import DialogView from '../../../Dialogos/DialogView'
import CamposPlanDeEmbarque from './CamposPlanDeEmbarque'
import { formValueSelector, reduxForm } from 'redux-form'
import * as actions from '../../actions/PlanDeEmbarqueActions'
import { CircularProgress } from '@material-ui/core'

function DialogoEdicionPlanDeEmbarqueBodega (props) {
  const { fechaDeReferencia, bodega, confirmCallback, confirmCerealChange, cancelCallback, detalleInicial, receiveDetalleInicial } = props
  const [dataInicial, setDataInicial] = useState(false)

  useEffect(() => {
    async function getDetalle () {
      props.getDetalleBodega(fechaDeReferencia, bodega)
    }
    if (!detalleInicial) { getDetalle() }
  }, [props, detalleInicial, fechaDeReferencia, bodega])

  async function getData () {
    const { change: formChange } = props
    formChange('bodega', detalleInicial.bodega)
    formChange('cereal', detalleInicial.cereal)
    formChange('cerealVariedad', detalleInicial.cerealVariedad !== 'UNDEF' ? detalleInicial.cerealVariedad : '')
    formChange('paisDestino', detalleInicial.paisDestino)
    formChange('peso', detalleInicial.pesoTotal)
  }

  if (receiveDetalleInicial && !dataInicial) {
    getData()
    console.log('detalle inicial ', detalleInicial)
    setDataInicial(true)
  }

  const handleSubmit = () => {
    const { cereal, cerealVariedad } = props
    console.log(detalleInicial.cereal !== cereal, ', ', detalleInicial.cereal, ' !== ', cereal)
    console.log(detalleInicial.cerealVariedad !== cerealVariedad, ', ', detalleInicial.cerealVariedad, ' !== ', cerealVariedad)
    if (detalleInicial.cereal !== cereal || detalleInicial.cerealVariedad !== cerealVariedad) {
      confirmCerealChange()
    } else {
      confirmCallback()
    }
  }

  return (
    <>
      { receiveDetalleInicial
        ? <DialogView
          confirmCallback={handleSubmit}
          cancelCallback={cancelCallback}
          title='Editar detalle de bodega'
          content={
            <CamposPlanDeEmbarque detalleInicial={detalleInicial} />
          }
        />
        : <div style={{ padding: '10% 0', display: 'flex', justifyContent: 'center' }} >
          <CircularProgress />
        </div>
      }

    </>
  )
}

const selector = formValueSelector('FORM_PLAN_DE_EMBARQUE')

const mapStateToProps = (state) => {
  return {
    detalleInicial: state.buque.detalleInicial,
    receiveDetalleInicial: state.buque.receiveDetalleInicial,
    cereal: selector(state, 'cereal'),
    cerealVariedad: selector(state, 'cerealVariedad')
  }
}

const withRedux = connect(mapStateToProps, actions)

const withReduxForm = reduxForm({
  form: FORM_PLAN_DE_EMBARQUE,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
  destroyOnUnmount: true,
  updateUnregisteredFields: true
})

export default withRedux(withReduxForm(DialogoEdicionPlanDeEmbarqueBodega))
